module.exports = __webpack_public_path__ + "assets/images/icons/eye.8b80e851eab94d6cd6cebf21d7981b9a.svg";